import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ObjectChat from '@/components/ObjectChat';

// Reusable dialog surface that hosts the object-attached chat (replaces the
// legacy StartDiscussionDialog trigger on insights / KPIs / other surfaces).
export default function ObjectChatDialog({ open, onOpenChange, objectType, objectId, label }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg h-[70vh] flex flex-col" data-testid="object-chat-dialog">
        <DialogHeader className="flex-none">
          <DialogTitle className="text-sm">{label || 'Discussion'}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0">
          {open && objectId && (
            <ObjectChat objectType={objectType} objectId={objectId} label={label} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
